import { MenuList, MenuPopover } from '@fluentui/react-components';
import React from 'react';
import { useActionMenuPopoverStyles } from './ActionContextMenuPopover.styles';
import { getMenuItems } from './ActionMenuItem';
import { groupDocumentActions } from './util';
export var ActionContextMenuPopover = function (_a) {
    var groupInfo = _a.groupInfo, items = _a.items, hidden = _a.hidden;
    var styles = useActionMenuPopoverStyles();
    return (React.createElement(MenuPopover, { className: styles.popOver, hidden: hidden !== null && hidden !== void 0 ? hidden : false },
        React.createElement(MenuList, { className: styles.menuItemsNoOutline }, getMenuItems(groupDocumentActions(items, groupInfo)))));
};
//# sourceMappingURL=ActionContextMenuPopover.js.map